export class ThreeCX {
  type: String;
  term: number;
  sc: number;
  addon: String;
  costMonthlySub: number;
  costMonthlyAddon: number;
  costMonthlySubEditable: boolean;

  constructor() {
    this.type = '';
    this.term = 0;
    this.sc = 0;
    this.addon = '';
    this.costMonthlySub = 0;
    this.costMonthlySubEditable = false;
    this.costMonthlyAddon = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/ThreeCX.ts